import React from 'react'
// libs
import { useSelector } from 'react-redux'
import { getFormValues } from 'redux-form'
// components
import ChartView from 'components/PageComponents/Home/components/DashboardWidgets/components/Chart/components/ChartView'
// constants
import { Forms } from 'constants/forms'
// types
import { ChartConfig } from 'types/charts'
// views
import { PreviewWrapper } from '../../views'
// utils
import { isChartConfigValid } from 'utils/charts/config'
import { ChartFormValues, getChartConfigFromForm } from '../../utils'

const getValues = getFormValues(Forms.DASHBOARD_WIDGET_SETTINGS_FORM)

const Preview: React.FC = () => {
  const values = useSelector(getValues) as ChartFormValues

  // A value the schema refuses is marked on its field: until it is fixed the chart keeps its last valid look instead of
  // falling back to the defaults whole
  const lastValidConfig = React.useRef<ChartConfig | null>(null)

  const config = React.useMemo(() => {
    if (values && isChartConfigValid(values.chartConfig)) {
      lastValidConfig.current = getChartConfigFromForm(values)
    }

    return lastValidConfig.current
  }, [values])

  return (
    <PreviewWrapper>
      <ChartView config={config} title={values?.chartTitle} />
    </PreviewWrapper>
  )
}

export default Preview
